import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from '@jd/jmtd-tools/es/classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isEmpty } from '../tools/util';
import ConfigConsumer from '../ConfigConsumer';
import ConfigProvider from '../ConfigProvider';

var Spin = function Spin() {
  return /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-container jmtd-loading-container1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle4"
  })), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-container jmtd-loading-container2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-loading-circle jmtd-loading-circle4"
  })));
};

var Loading = /*#__PURE__*/function (_Component) {
  _inherits(Loading, _Component);

  var _super = _createSuper(Loading);

  function Loading() {
    _classCallCheck(this, Loading);

    return _super.apply(this, arguments);
  }

  _createClass(Loading, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.timer && clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          size = _this$props.size,
          className = _this$props.className,
          children = _this$props.children,
          tip = _this$props.tip,
          loading = _this$props.loading,
          delay = _this$props.delay,
          indicator = _this$props.indicator,
          autoMinHeight = _this$props.autoMinHeight;
      return /*#__PURE__*/React.createElement(ConfigConsumer, {
        size: size,
        loadingIndicator: indicator
      }, function (_ref) {
        var _ref$loadingIndicator = _ref.loadingIndicator,
            loadingIndicator = _ref$loadingIndicator === void 0 ? /*#__PURE__*/React.createElement(Spin, null) : _ref$loadingIndicator,
            configSize = _ref.size;
        var loadingStatus;

        if (delay) {
          // 如果有延迟，spinning与当前spinning不符合并且没有计时器，启用计时器
          if (_this.currentLoading !== loading) {
            if (!_this.timer) {
              _this.timer = setTimeout(function () {
                _this.currentLoading = loading;
                _this.timer = null;

                _this.forceUpdate();
              }, delay);
            }
          } else if (_this.timer) {
            clearTimeout(_this.timer);
            _this.timer = null;
          }

          loadingStatus = _this.currentLoading;
        } else {
          loadingStatus = loading;
        }

        var emptyShow = /*#__PURE__*/React.createElement(ConfigProvider, {
          size: size
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-loading-wrapper"
        }, loadingIndicator, tip && /*#__PURE__*/React.createElement("div", {
          className: "jmtd-loading-tip"
        }, tip)));
        var loadingShow = isEmpty(children) ? emptyShow : /*#__PURE__*/React.createElement("div", {
          className: "jmtd-loading-wall"
        }, emptyShow);
        return /*#__PURE__*/React.createElement("div", {
          id: id,
          className: classNames('jmtd-loading', className, configSize, {
            'jmtd-loading-auto-min-height': autoMinHeight,
            'jmtd-loading-in-loading': loadingStatus
          })
        }, loadingStatus && loadingShow, children);
      });
    }
  }]);

  return Loading;
}(Component);

export { Loading as default };
Loading.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['mini', 'middle', 'small', 'large']),
  tip: PropTypes.string,
  loading: PropTypes.bool,
  delay: PropTypes.number,
  indicator: PropTypes.node,
  autoMinHeight: PropTypes.bool
};
Loading.defaultProps = {
  id: null,
  children: null,
  className: '',
  size: null,
  tip: '',
  loading: false,
  delay: 0,
  indicator: null,
  autoMinHeight: false
};